import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  /* === Base (≥1920) ===================================================== */
  container: {
    height: 'calc(100vh - 90px)',
    boxSizing: 'border-box',
    padding: '24px 24px',
    gap: '16px',
    display: 'flex',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
      display: 'none !important',
    },
    scrollbarWidth: 'none !important',
    msOverflowStyle: 'none !important',
  },

  smallPagination: {
    "& .MuiTablePagination-caption": { flexShrink: 0, fontSize: 12 },
    "& .MuiTablePagination-selectRoot": { fontSize: 12 },
    "& .MuiTablePagination-displayedRows": { fontSize: 12 },
    "& .MuiTablePagination-actions .MuiIconButton-root": { padding: 4 },
    "& .MuiTablePagination-actions svg": { fontSize: 16 },
  },

  modal: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
  paper: { backgroundColor: '#fff', boxShadow: 'none' },

  topBar: {
    height: 32,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    boxSizing: 'border-box',
  },
  backIconBox: {
    height: 32,
    boxSizing: 'border-box',
    width: 32,
    padding: 4,
    backgroundColor: 'rgba(250, 250, 254, 1)',
    border: '1px solid rgba(233, 235, 245, 1)',
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    flexShrink: 0,
  },
  backIconImg: { height: 14, width: 14 },

  headerTitle: {
    fontSize: 24,
    fontWeight: 500,
    lineHeight: '30px',
  },

  outerCard: {
    border: '1px solid rgba(213, 214, 221, 1)',
    borderRadius: 8,
    boxSizing: 'border-box',
  },

  stepHeader: {
    height: 115,
    borderBottom: '1px solid rgba(233, 235, 245, 1)',
    padding: 24,
    boxSizing: 'border-box',
    display: 'flex',
    gap: 20,
    minWidth: 355,
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      display: 'none !important',
    },
    scrollbarWidth: 'none !important',
    msOverflowStyle: 'none !important',
  },

  /* Cards */
  stepCardActive: {
    height: 66,
    padding: 12,
    backgroundColor: '#F5F7FF',
    borderRadius: 4,
    display: 'flex',
    gap: 12,
    alignItems: 'center',
    boxSizing: 'border-box',
    flex: '0 0 auto',
  },
  stepCardUpcoming: {
    height: 66,
    padding: 12,
    borderRadius: 4,
    display: 'flex',
    gap: 12,
    alignItems: 'center',
    boxSizing: 'border-box',
    cursor: 'pointer',
    flex: '0 0 auto',
  },
  stepCardCompleted: {
    height: 66,
    padding: 12,
    borderRadius: 4,
    display: 'flex',
    gap: 12,
    alignItems: 'center',
    boxSizing: 'border-box',
    cursor: 'pointer',
    flex: '0 0 auto',
  },

  stepNumberText: { fontSize: 16, fontWeight: 500, lineHeight: '21px', color: '#fff' },
  stepNumberActive: {
    height: 32, width: 32, backgroundColor: '#5769CD', borderRadius: 25,
    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
  },
  stepNumberUpcoming: {
    height: 32, width: 32, backgroundColor: 'rgba(146, 147, 166, 1)', borderRadius: 25,
    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
  },
  stepTick: {
    height: 32, width: 32, backgroundColor: 'rgba(70, 159, 124, 1)', borderRadius: 25,
    display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0,
  },
  stepTickIcon: { height: 14, width: 14 },
  stepTextWrap: { display: 'flex', flexDirection: 'column', gap: 4, minWidth: 0 },

  stepLabelActive: {
    fontSize: 14, fontWeight: 500, lineHeight: '21px', color: 'rgba(87, 105, 205, 1)',
  },
  stepSupportingActive: {
    fontSize: 12, fontWeight: 400, lineHeight: '15px', color: 'rgba(87, 105, 205, 1)',
    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 311,
  },

  stepLabelUpcoming: {
    fontSize: 14, fontWeight: 500, lineHeight: '21px', color: 'rgba(146, 147, 166, 1)',
  },
  stepSupportingUpcoming: {
    fontSize: 12, fontWeight: 400, lineHeight: '15px', color: 'rgba(146, 147, 166, 1)',
    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 311,
  },

  stepLabelCompleted: {
    fontSize: 14, fontWeight: 500, lineHeight: '21px', color: 'rgba(69, 70, 83, 1)',
  },
  stepSupportingCompleted: {
    fontSize: 12, fontWeight: 400, lineHeight: '15px', color: 'rgba(69, 70, 83, 1)',
    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 311,
  },

  finishedText: {
    fontSize: 14, fontWeight: 400, lineHeight: '24px', color: 'rgba(120, 121, 142, 1)',
  },

  contentScroll: {
    overflowY: 'auto',
    maxHeight: 650,
    boxSizing: 'border-box',
    '&::-webkit-scrollbar': {
      display: 'none !important',
    },
    scrollbarWidth: 'none !important',
    msOverflowStyle: 'none !important',
  },

  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 38,
    marginBottom: '20px',
    boxSizing: 'border-box',
    gap: 12,
  },

  prevBtn: {
    height: 38,
    minWidth: 90,
    padding: '12px 16px',
    backgroundColor: 'transparent',
    borderRadius: 4,
    border: '1px solid #3F51B5',
    color: 'rgba(63, 81, 181, 1)',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      border: '1px solid #3F51B5',
      boxShadow: 'none',
    },
  },

  primaryBtn: {
    height: 38,
    minWidth: 61,
    padding: '12px 16px',
    backgroundColor: '#3F51B5',
    borderRadius: 4,
    border: '1px solid #3F51B5',
    color: 'rgba(255, 255, 255, 1)',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#3F51B5',
      borderColor: '#3F51B5',
      boxShadow: 'none',
    },
  },

  primaryBtnUpdate: {
    height: 38,
    minWidth: 90,
    padding: '5px 8px',
    backgroundColor: '#3F51B5',
    borderRadius: 4,
    border: '1px solid #3F51B5',
    color: 'rgba(255, 255, 255, 1)',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#3F51B5',
      borderColor: '#3F51B5',
      boxShadow: 'none',
    },
  },

  /* === ≤1600 ============================================================ */
  '@media (max-width:1600px)': {
    container: { padding: '20px 20px' },
    headerTitle: { fontSize: 22, lineHeight: '28px' },
    stepHeader: { gap: 16 },
    contentScroll: { maxHeight: 600 },
  },

  /* === ≤1440 (NEW) ====================================================== */
  '@media (max-width:1440px)': {
    container: { padding: '18px 18px' },
    headerTitle: { fontSize: 21, lineHeight: '28px' },

    stepHeader: {
      height: 112,
      padding: 22,
      gap: 14,
      overflowX: 'auto',               /* allow gentle horizontal scroll if many steps */
      WebkitOverflowScrolling: 'touch',
    },

    /* give cards a gentle floor so they don’t collapse too narrow */
    stepCardActive: { minWidth: 300 },
    stepCardUpcoming: { minWidth: 300 },
    stepCardCompleted: { minWidth: 300 },

    /* slightly tighter supporting text width */
    stepSupportingActive: { maxWidth: 280 },
    stepSupportingUpcoming: { maxWidth: 280 },
    stepSupportingCompleted: { maxWidth: 280 },

    contentScroll: { maxHeight: 580 },

    /* Buttons spacing stays comfortable */
    footer: { gap: 10 },
  },

  /* === ≤1366 ============================================================ */
  '@media (max-width:1366px)': {
    headerTitle: { fontSize: 20, lineHeight: '26px' },
    backIconBox: { height: 28, width: 28 },
    backIconImg: { height: 12, width: 12 },

    stepHeader: {
      height: 110,
      padding: 20,
      gap: 12,
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch',
    },

    /* make step cards a bit narrower so more fit inline */
    stepCardActive: { padding: 10, gap: 10, minWidth: 280 },
    stepCardUpcoming: { padding: 10, gap: 10, minWidth: 280 },
    stepCardCompleted: { padding: 10, gap: 10, minWidth: 280 },

    stepSupportingActive: { maxWidth: 260 },
    stepSupportingUpcoming: { maxWidth: 260 },
    stepSupportingCompleted: { maxWidth: 260 },

    contentScroll: { maxHeight: 560 },
  },

  /* === ≤1280 ============================================================ */
  '@media (max-width:1280px)': {
    container: { padding: '16px 16px' },
    headerTitle: { fontSize: 18, lineHeight: '24px' },

    stepNumberActive: { height: 28, width: 28 },
    stepNumberUpcoming: { height: 28, width: 28 },
    stepTick: { height: 28, width: 28 },
    stepNumberText: { fontSize: 14, lineHeight: '18px' },

    stepLabelActive: { fontSize: 13 },
    stepLabelUpcoming: { fontSize: 13 },
    stepLabelCompleted: { fontSize: 13 },

    stepSupportingActive: { fontSize: 11, maxWidth: 220 },
    stepSupportingUpcoming: { fontSize: 11, maxWidth: 220 },
    stepSupportingCompleted: { fontSize: 11, maxWidth: 220 },

    contentScroll: { maxHeight: 520 },

    /* Buttons shrink a bit, allow wrapping on small widths */
    footer: { gap: 8 },
    prevBtn: { minWidth: 80, padding: '10px 14px' },
    primaryBtn: { minWidth: 56, padding: '10px 14px' },
    primaryBtnUpdate: { minWidth: 84, padding: '4px 8px' },
  },

  /* === ≤1024 (target) =================================================== */
  '@media (max-width:1024px)': {
    container: { padding: '14px 14px' },

    /* Step header turns into a horizontally scrollable row of compact chips */
    stepHeader: {
      height: 'auto',
      minHeight: 96,
      padding: 16,
      gap: 10,
      overflowX: 'auto',
      overflowY: 'hidden',
      whiteSpace: 'nowrap',
    },

    stepCardActive: {
      height: 'auto',
      minHeight: 56,
      minWidth: 240,
      padding: 10,
      borderRadius: 6,
    },
    stepCardUpcoming: {
      height: 'auto',
      minHeight: 56,
      minWidth: 240,
      padding: 10,
      borderRadius: 6,
    },
    stepCardCompleted: {
      height: 'auto',
      minHeight: 56,
      minWidth: 240,
      padding: 10,
      borderRadius: 6,
    },

    stepNumberActive: { height: 26, width: 26 },
    stepNumberUpcoming: { height: 26, width: 26 },
    stepTick: { height: 26, width: 26 },
    stepNumberText: { fontSize: 13 },

    stepTextWrap: { gap: 2 },
    stepLabelActive: { fontSize: 12, lineHeight: '18px' },
    stepLabelUpcoming: { fontSize: 12, lineHeight: '18px' },
    stepLabelCompleted: { fontSize: 12, lineHeight: '18px' },

    stepSupportingActive: { fontSize: 10, maxWidth: 200, lineHeight: '14px' },
    stepSupportingUpcoming: { fontSize: 10, maxWidth: 200, lineHeight: '14px' },
    stepSupportingCompleted: { fontSize: 10, maxWidth: 200, lineHeight: '14px' },

    contentScroll: { maxHeight: 'calc(100vh - 320px)' },

    /* Buttons line up tighter and can auto-size */
    footer: {
      gap: 8,
      height: 'auto',
      paddingTop: 6,
    },
    prevBtn: {
      minWidth: 72,
      padding: '8px 12px',
      fontSize: 13,
      lineHeight: '18px',
    },
    primaryBtn: {
      minWidth: 56,
      padding: '8px 12px',
      fontSize: 13,
      lineHeight: '18px',
    },
    primaryBtnUpdate: {
      minWidth: 80,
      padding: '4px 8px',
      fontSize: 13,
      lineHeight: '18px',
    },

    /* Top bar density */
    topBar: { gap: 8 },
    backIconBox: { height: 26, width: 26, padding: 3 },
    backIconImg: { height: 11, width: 11 },
    headerTitle: { fontSize: 16, lineHeight: '22px' },
  },
}));

export default useStyles;
